import { render, staticRenderFns } from "./CookiesAccept.vue?vue&type=template&id=b9a41832&scoped=true&"
import script from "./CookiesAccept.vue?vue&type=script&lang=js&"
export * from "./CookiesAccept.vue?vue&type=script&lang=js&"
import style0 from "./CookiesAccept.css?vue&type=style&index=0&id=b9a41832&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a41832",
  null
  
)

export default component.exports